import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import '../stylesheet/latestmovies.css';
import { useGetMoviesDataQuery } from '../services/moviesData';
import ImageChecker from './Reusable/ImageChecker';
import { useDispatch } from 'react-redux';
import { setUpMovie } from '../features/movieSlice';
import { useNavigate } from 'react-router-dom';

const ModalStyles = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#FFF',
  zIndex: 1000,
  borderRadius: '10px',
};

const overlayStyles = {
  position: 'fixed',
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  zIndex: 1000,
};

const closeButtonStyles = {
  position: 'absolute',
  top: '-10px',
  right: '-10px',
  zIndex: 1,
  backgroundColor: '#F150AC',
  color: '#FFFFFF',
  padding: '2px',
  border: 'none',
  borderRadius: '5px',
};

const MemoizedMovieCard = React.memo(({ item, handleBookTickets }) => {
  const [open, setOpen] = useState(false);

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  return (
    <li>
      <ImageChecker imageUrl={item[1]['poster']}>
        <div style={{ color: 'inherit' }} onClick={openModal}>
          <Card style={{ width: '16rem', height: '26rem' }}>
            <Card.Img
              style={{
                width: '15rem',
                height: '22rem',
                display: 'block',
                margin: '0 auto',
                borderRadius: '10px',
                paddingTop: '10px',
              }}
              variant="top"
              src={item[1]['poster']}
            />
            <div className='cardtext'>
              <Card.Title >{item[1]['title']}</Card.Title>
              <Card.Text>
                {item[1]['released'] ? item[1]['released'].split(' ').splice(0, 3).join(' ') : <div></div>}
              </Card.Text>
            </div>
          </Card>
        </div>
      </ImageChecker>
      {open && (
        <div>
          <div style={overlayStyles} onClick={closeModal} />
          <div style={ModalStyles}>
            <Card style={{ width: '18rem' }}>
              <button className='close' onClick={closeModal} style={closeButtonStyles}>
                X
              </button>
              <Card.Img variant='top' src={item[1]['poster']} style={{ borderRadius: '10px' }} />
              <Card.Body>
                <Card.Title>{item[1]['title']}</Card.Title>
                <button className='button-1' onClick={handleBookTickets}>
                  Book tickets
                </button>
              </Card.Body>
            </Card>
          </div>
        </div>
      )}
    </li>
  );
});

export default function LatestMovies({ location }) {
  const { data } = useGetMoviesDataQuery(location);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleBookTickets = (selectedData) => {
    dispatch(setUpMovie(selectedData));
    navigate('/booking');
  };

  return (
    <div style={{ paddingTop: '20px', height: '100vh', width: '90%', margin: '0 auto' }}>
      <h3 style={{ paddingLeft: '20px', color:'#272a3d' }}>Movies in {location}</h3>

      <div className='main' style={{ paddingTop: '20px' }}>
        {data ? (
          <ul>
            {Object.entries(data).map((item) =>
              item[1]['poster'] ? (
                <MemoizedMovieCard key={item[0]} item={item} handleBookTickets={() => handleBookTickets(item[1])} />
              ) : null
            )}
          </ul>
        ) : (
          <p>Loading data...</p>
        )}
      </div>
    </div>
  );
}
